import React, { useRef, useEffect } from 'react';
import get from 'lodash/get';

import useFileUpload from '../hooks/useFileUpload';

import FileProgress from './FileProgress.jsx';

const FileSlide = (props) => {
  const {
    api,
    value,
    onChange = () => {},
    className = 'file-slide-cover',
    children,
  } = props;
  const [res, req, , progress] = useFileUpload();
  const display = useRef(value);
  const isPending = res.status === 'pending';

  useEffect(() => {
    if (value instanceof File) {
      (async () => {
        display.current = URL.createObjectURL(value);
        const { payload } = await req(api, value);

        onChange(payload.url);
      })();
    }
    const type = get(value, 'type', value);
    if (type) {
      const isPdf = type === 'application/pdf' || type.split('.').at(-1) === 'pdf';
      if (isPdf) {
        display.current = '../../../assets/img/PDF_file_icon.svg';
      }
    }
  }, [
    value instanceof File,
    get(value, 'name') || value,
    get(value, 'lastModified'),
  ]);

  return (
    <div className={className}>
      {display.current && (
        <div
          className={`img-bg ${isPending ? 'opacity-7' : ''}`}
          style={{ backgroundImage: `url('${display.current}')` }}
        ></div>
      )}
      {isPending ? (
        <div className="pos-abs-center opacity-9">
          <span className="btn btn-secondary">
            <FileProgress progress={progress} />
          </span>
        </div>
      ) : children}
    </div>
  );
};

export default FileSlide;
